export const vacncsproperties = [
  {
    value: 'Casa Rentals LLC - 912 N Creek Drive  Edmond, OK 73034',
    label: 'Casa Rentals LLC - 912 N Creek Drive  Edmond, OK 73034',
  },
  {
    value: 'test1 - 912 n creek dr  edmond, OK 73034',
    label: 'test1 - 912 n creek dr  edmond, OK 73034',
  },
  {
    value: 'test group',
    label: 'test group',
  }
]
export const vacncsbedrooms = [
  {
    value: '0+',
    label: '0+',
  },
  {
    value: '01+',
    label: '01+',
  },
  {
    value: '02+',
    label: '02+',
  },
  {
    value: '03+',
    label: '03+',
  },
  {
    value: '04+',
    label: '05+',
  },
  {
    value: '05+',
    label: '05+',
  }
]
export const vacncssortby = [
  {
    value: 'Days Vacant',
    label: 'Days Vacant',
  },
  {
    value: 'Internet Posting Status',
    label: 'Internet Posting Status',
  },
  {
    value: 'Name',
    label: 'Name',
  },
  {
    value: 'Market Rent',
    label: 'Market Rent',
  },
  {
    value: 'Advertised Rent',
    label: 'Advertised Rent',
  },
  {
    value: 'Website Posting Status',
    label: 'Website Posting Status',
  },
  {
    value: 'Bedrooms',
    label: 'Bedrooms',
  },
  {
    value: 'Available Date',
    label: 'Available Date',
  },
]
export const guestcardsreport = [

    {
        key: '1',
        name: 'John Smith',
        age: 32,
        address: 'Lorem ipsum dolor sit amet,',
        tags: ['Lorem ipsum', 'Lorem ipsum'],
      },
      {
        key: '2',
        name: 'Jim Green',
        age: 42,
        address: 'Lorem ipsum dolor sit amet,',
        tags: ['Lorem ipsum'],
      },
      {
        key: '3',
        name: 'Joe Black',
        age: 32,
        address: 'Lorem ipsum dolor sit amet,',
        tags: ['Lorem ipsum', 'Lorem ipsum'],
      },

]
export const guestcardinbox = [

  {
    key: '1',
    title: 'Needs First Contact',
    body: "There's nothing to see here. You're all caught up!",
    notification: 1,
  },
  {
    key: '2',
    title: 'Needs Follow Up',
    body: "There's nothing to see here. You're all caught up!2",
    notification: 2,
  },
  {
    key: '3',
    title: 'Going Cold',
    body: "There's nothing to see here. You're all caught up! 3",
    notification: 4,
  },
]
export const vcncsreprtcnt = [
  {
    key: '1',
    name: '-- --',
    age: '-- --',
    address: '-- --',
  },
]
export const contactinfo = 
  {
    title: "Vacancy Posting Contact Settings:",
    phone: "(405) 283-6521 ",
    email: "this.getinstance@gmail.com",
    key: '1',
  }

  export const bulkPostVacancies = [
  {
    name: "test 2",
    postingStatus: " Unposted",
    missingInfoPercent: 15
  }
  ];

  export const html = `Coming soon- Nice 4 bedroom 2 bath home in Mid-Del School District: 1817 Treat Drive 

  Property Address 
  1817 Treat Drive | Midwest City, OK 73110 
  Available: 03/01/2023 
  
  Offered By 
  Integrity Oklahoma LLC 
  
  
  Description
  Nice 4 bedroom 2 bath home in Mid-Del School District. Featuring central heat and air, ceiling fans, neutral paint colors throughout, and a fenced in backyard. 
  Spacious kitchen with plenty of cabinets for storage and a gas range. Laundry room with connections for a washer and electric dryer. Rent is $1200 per month and 
  deposit is $1200. Tenant is responsible for utilities and yard maintenance. Pets not accepted. To schedule a showing and apply online, visit integrityokc.com. 
  
  We offer a $0 Security Deposit Move in option. This is a security deposit waiver program. Let us know if you have any questions about the program to save you 
  money at move in. The monthly fee is based on the highest credit score in your household and will be a between 3% and 10% of your monthly rent each monthplus 
  a sign up fee of $50. You can also opt to pay the full security deposit at move in on some properties. You will need to pay your first months rent when 
  approved if you opt for the Security Deposit Waiver program. 
  
  This home does not accept housing assistance programs. 
  
  Integrity Oklahoma does not advertise on Craigslist or Facebook. We will never ask you to wire money or pay with gift cards. Please report Fraudulent 
  ads to your Property Manager. Verify all information with one of our property managers which are listed on our website at integrityokc.com prior to 
  leasing or paying any deposit for a property. The property owner will NEVER contact you to lease or view this home. 
  
  We do not accept Zillow applications or any other third party applications. All applications must be processed through Integrityokc.com 
  
  There is a Lease Prep fee of $75 that is due at the time of lease signing. Remember to set up a showing just visit integrityokc.com 
  and fill out the contact us form on the property page for this home! We will then request some additional info to enable us to set up a 
  showing with you right away!
  
  Details
  Beds/Baths: 4BD/2.0BA
  Square Feet: 1,196
  Rental Terms
  Rent: $1,200.00
  Available: 03/01/2023
  Application Fee: $45.00
  Security Deposit: $1,200.00
  Pet Policy
  Cats not allowed
  Dogs not allowed`;

 export const content = `  <big>
<big>
  <b style="font-family: sans-serif">Coming soon- Nice 4 bedroom 2 bath home in Mid-Del School District: 1817 Treat Drive</b>
</big>
</big>
<br>
<br>
<b style="font-family: sans-serif">Property Address</b>
<br>
<span style="font-family: sans-serif">1817 Treat Drive | Midwest City, OK 73110</span>
<br>

<span style="font-family: sans-serif">Available: 03/01/2023</span>

<br>
<br>
<b style="font-family: sans-serif">Offered By</b>
<br>
<span style="font-family: sans-serif">Integrity Oklahoma LLC</span>
<br>
<br>
<hr>
<br>
<b style="font-family: sans-serif">Description</b>
<blockquote style="font-family: sans-serif">
Nice 4 bedroom 2 bath home in Mid-Del School District. Featuring central heat and air, ceiling fans, neutral paint colors throughout, and a fenced in backyard. Spacious kitchen with plenty of cabinets for storage and a gas range. Laundry room with connections for a washer and electric dryer. Rent is $1200 per month and deposit is $1200. Tenant is responsible for utilities and yard maintenance. Pets not accepted. To schedule a showing and apply online, visit integrityokc.com.
<br/>
<br/>We offer a $0 Security Deposit Move in option.  This is a security deposit waiver program.  Let us know if you have any questions about the program to save you money at move in.  The monthly fee is based on the highest credit score in your household and will be a  between 3% and 10% of your monthly rent each monthplus a sign up fee of $50.  You can also opt to pay the full security deposit at move in on some properties. You will need to pay your first months rent when approved if you opt for the Security Deposit Waiver program.
<br/>
<br/>This home does not accept housing assistance programs. 
<br/>
<br/>Integrity Oklahoma does not advertise on Craigslist or Facebook.  We will never ask you to wire money or pay with gift cards.  Please report Fraudulent ads to your Property Manager.  Verify all information with one of our property managers which are listed on our website at integrityokc.com prior to leasing or paying any deposit for a property.  The property owner will NEVER contact you to lease or view this home.
<br/>
<br/>We do not accept Zillow applications or any other third party applications.  All applications must be processed through Integrityokc.com
<br/>
<br/>There is a Lease Prep fee of $75 that is due at the time of lease signing.  Remember to set up a showing just visit integrityokc.com and fill out the contact us form on the property page for this home!  We will then request some additional info to enable us to set up a showing with you right away!
</blockquote>


<b style="font-family: sans-serif">Details</b>
<ul style="font-family: sans-serif">

  <li>Beds/Baths: 4BD/2.0BA</li>
  <li>Square Feet: 1,196</li>

</ul>

<b style="font-family: sans-serif">Rental Terms</b>
<ul style="font-family: sans-serif">

<li>Rent: $1,200.00 

<li>Available: 03/01/2023
<li>Application Fee: $45.00
<li>Security Deposit: $1,200.00

</ul>

<b style="font-family: sans-serif">Pet Policy</b>
<ul style="font-family: sans-serif">

  <li>Cats not allowed</li>
  <li>Dogs not allowed</li>

</ul>
`;